/* global OfficeRuntime  */
import { ReactNode } from "react";
import * as React from "react";
import { useState } from "react";
import { useAppState } from "../context/AppContext";
import { jwtDecode } from "jwt-decode";

export const AuthGuard = ({
  children,
  notLoggedInComponent,
}: {
  children: ReactNode;
  notLoggedInComponent: ReactNode;
}) => {
  const { state, dispatch } = useAppState();
  const [error, setError] = useState("");

  const authenticateUser = async () => {
    try {
      let encodedToken = await OfficeRuntime.auth.getAccessToken({
        allowSignInPrompt: true,
        allowConsentPrompt: true,
      });
      const claims = jwtDecode<{ preferred_username: string }>(encodedToken);
      dispatch(["SET_SELLER", { seller: claims.preferred_username.toLowerCase() }]);
      dispatch(["SET_AUTH_STATE", { state: "LOGGED_IN" }]);
    } catch (exception) {
      setError(
        `Klarte ikke å logge inn, forsøk igjen. (Feilkode ${(exception as any).code || "ukjent"})`
      );
    }
  };

  React.useEffect(() => {
    authenticateUser();
  }, []);

  if (state.authState === "NOT_LOGGED_IN") {
    return (
      <>
        {error}
        {notLoggedInComponent}
      </>
    );
  }

  return <>{children}</>;
};

// // FALLBACK - keep for now
// React.useEffect(() => {
//   return;
//   async () => {
//     try {
//       const user = await msal.getAllAccounts()?.[0];
//       if (user) {
//         await msal.setActiveAccount(user);
//         const token = await msal.acquireTokenSilent({ scopes: ["User.Read"] });
//         dispatch(["SET_AUTH_STATE", { state: "LOGGED_IN" }]);
//         dispatch(["SET_SELLER", { seller: user.username.toLowerCase() }]);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
// }, []);
